import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=d9b13ac0&scoped=true"
import script from "./wrapper.vue?vue&type=script&lang=js"
export * from "./wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b13ac0",
  null
  
)

export default component.exports